import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ConstructionQaInspectionsService } from '../services/constructionQaInspections.service';
import { ConstructionQaStatsService } from '../services/constructionQaStats.service';
import type { ConstructionQaInspection, QaFilters } from '../types/construction-qa.types';
import { useState } from 'react';
import { toast } from 'sonner';

export function useConstructionQaInspections(companyId: string, initialFilters: QaFilters = {}) {
  const queryClient = useQueryClient();
  const [filters, setFilters] = useState<QaFilters>({
    status: 'all',
    ...initialFilters
  });

  const query = useQuery({
    queryKey: ['construction-qa-inspections', companyId, filters],
    queryFn: () => ConstructionQaInspectionsService.getInspections(companyId, filters),
    enabled: !!companyId,
  });

  const statsQuery = useQuery({
    queryKey: ['construction-qa-stats', companyId, filters.projectId],
    queryFn: () => ConstructionQaStatsService.getQaStats(companyId, filters.projectId),
    enabled: !!companyId,
  });

  const createMutation = useMutation({
    mutationFn: (data: Partial<ConstructionQaInspection>) => ConstructionQaInspectionsService.createInspection(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['construction-qa-inspections'] });
      queryClient.invalidateQueries({ queryKey: ['construction-qa-stats'] });
      toast.success('Tạo phiếu kiểm tra QA thành công');
    },
  });

  return {
    inspections: query.data?.data || [],
    total: query.data?.total || 0,
    stats: statsQuery.data,
    isLoading: query.isLoading || statsQuery.isLoading,
    filters,
    setFilters,
    createInspection: createMutation.mutateAsync,
    isCreating: createMutation.isPending,
  };
}
